<template>
  <div style="padding: 20px;height: 100%">
    <div style="display: flex;align-items: center;">
      <el-input v-model="keyUserId" placeholder="请输入用户设备号" style="width: 300px" allowClear="true"  clearable/>


      <el-button style="margin-left: 20px;width: 100px" type="primary" @click="getUserPayList">搜索</el-button>
    </div>
    <el-table stripe="true" border="true"  :data="transactionListData" size="large" style="height: 80%;width: 100%;margin-top: 20px">
      <el-table-column label="设备号" prop="deviceId" width="500px" align="center"/>
      <!--            <el-table-column label="用户ID" prop="userId" width="300px" align="center"/>-->


      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button type="danger" style="margin-left: 20px" @click="delBlock(scope.row.deviceId)" >解除封禁</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 20px;margin-bottom:20px;justify-content: center"  background layout="prev, pager, next" :total="totalCount" v-model:current-page="currentPage" @change="showSizeChange" :page-size="12" />
  </div>

</template>
<script>
import {$http} from "@/api";
import { ElMessage } from 'element-plus'
import {ElMessageBox} from "element-plus";
import {useRouter} from "vue-router";

export default {
  name:'BlockListPage',
  data(){
    return{
      transactionListData:[],
      currentPage:1, //当前页码
      totalCount:0, //服务器返回总数量
      keyUserId:'', // 搜索用ID
      router:useRouter()
    }
  },
  mounted(){
    // if()

    if(this.$route.query['userId'])
    {
      this.keyUserId = this.$route.query['userId']
    }
    this.getChannelList()
    this.getUserPayList()


  },
  methods:{
    // 获取列表
    getUserPayList(){
      const formData = new FormData();
      formData.append('currentPage', this.currentPage)
      formData.append('pageCount', '12');
      formData.append('deviceId',this.keyUserId)
      //

      $http('/get_block_list',formData)
          .then(res=>{

            this.transactionListData = res['resource']
            this.totalCount = res['totalCount']

          })

    },
    // 获取渠道列表
    getChannelList(){
      const formData = new FormData();
      $http('/get_channel',formData)
          .then(res=>{

            let resource = res['resource']

            this.sysOptions = []
            this.sysOptions.push({value:'-1',lable:"所有"})
            for (let bean in resource)
            {
              this.sysOptions.push({value:resource[bean].name,lable:resource[bean].name})
            }
          })
    },
    // 页码回调
    showSizeChange(current,size){
      this.urrentPage = current
      this.getUserPayList()
    },
    // 渠道回调
    keyIsSysChange(value){
      this.channel = value
    },
    // 状态回调
    keyIsStatusChange(value)
    {
      this.status = value
    },
    // 删除订单
    delBlock(id){
      let self = this;
      ElMessageBox.confirm(
          '确认解除封禁？该操作不可逆',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(() => {
        const formData = new FormData()
        formData.append('deviceId',id)

        $http('/del_block',formData)
            .then(res=>
            {
              ElMessage({
                message: '解除成功',
                type: 'success',
              })
              self.getUserPayList()
            })
      }).catch(() => {

      })

    }
  }
}
</script>